import * as Q from 'q';
import * as $ from 'jquery';
import * as ko from 'knockout';
import * as globalConfig from 'globalConfig';

// Models
import { HomeClubConfigurationResponse } from "Content/ts/Models/Shared/ClubSelector/clubConfiguration";
import { ClubLocationSelectorResponse } from "Content/ts/Models/Shared/ClubSelector/multipleClubSelector";

export module ClubSelectionService {
    export function RetrieveClubHierarchy(url?: string, params?: any): Q.Promise<Array<ClubLocationSelectorResponse>> {
        return Q($.ajax({
            url: url || globalConfig.Urls.Facility.GetFacilityHierarchy,
            method: "GET",
            data: params ? ko.toJS(params) : {}
        }));
    };

    export function RetrieveDefaultClub(): Q.Promise<HomeClubConfigurationResponse> {
        return Q($.ajax({
            url: globalConfig.Urls.Facility.RetrieveDefaultClub,
            method: "GET"
        }));
    };
}